import { RootState } from '../../store';

export const selectUserSubmittedLabResults = (state: RootState) =>
  state.userSubmittedLabResults.list;

export const selectUserSubmittedListError = (state: RootState) =>
  state.userSubmittedLabResults.listError;

export const selectCurrentError = (state: RootState) => state.userSubmittedLabResults.currentError;

export const selectLoading = (state: RootState) => state.userSubmittedLabResults.loadingCurrent;

export const selectLoadingBiomarker = (state: RootState) =>
  state.userSubmittedLabResults.loadingBiomarker;

export const selectPage = (state: RootState) => state.userSubmittedLabResults.page;

export const selectFilter = (state: RootState) => state.userSubmittedLabResults.filter;

export const selectDisableNext = (state: RootState) => state.userSubmittedLabResults.disableNext;

export const selectCurrentUserSubmittedLabResult = (state: RootState) =>
  state.userSubmittedLabResults.current;

export const selectBiomarkers = (state: RootState) => state.userSubmittedLabResults.biomarkers;

export const selectSavingSuccessful = (state: RootState) =>
  state.userSubmittedLabResults.savingSuccessful;

export const selectAutomatedStatusChange = (state: RootState) =>
  state.userSubmittedLabResults.automatedStatusChange;

export const selectShouldRedirect = (state: RootState) =>
  state.userSubmittedLabResults.shouldRedirect;
